export default __webpack_public_path__ + "media/hero-chart.f39a3b13.svg";